import script from "./ReferencesModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReferencesModal.vue?vue&type=script&setup=true&lang=ts"

import "./ReferencesModal.vue?vue&type=style&index=0&id=5136c38e&lang=scss"

const __exports__ = script;

export default __exports__